/** Au-delà, la requête est refusée : un lot se relit avant d'être confirmé. */
export const PLAFOND_LOT_OEUVRES = 500;
export const ACTIONS_LOT_OEUVRES = [
    'statut',
    'localisation',
    'publication',
    'exposition',
    'selection',
    'archivage',
    'prix',
];
/**
 * Les statuts qu'un lot peut viser. Vendue, réservée et louée ont leur
 * parcours (vente, réservation, contrat) ; l'archivage a son action.
 */
export const STATUTS_CIBLES_LOT = [
    'disponible',
    'en_depot',
    'pretee',
    'retiree',
];
/** Pas d'arrondi du prix, en centimes : du centime au millier. */
export const PAS_ARRONDI_CENTIMES = [1, 100, 1_000, 5_000, 10_000, 50_000, 100_000];
export const SENS_ARRONDI = ['plus_proche', 'superieur', 'inferieur'];
/** Bornes de la variation en pourcentage : jamais −100 % par une faute de frappe. */
export const POURCENTAGE_LOT_MIN = -90;
export const POURCENTAGE_LOT_MAX = 1000;
export const RESULTATS_LIGNE_LOT = ['modifiee', 'inchangee', 'refusee'];
/** Une variation en pourcentage, en points de base entiers (10 % → 1 000). */
export function pointsDeBaseDe(pourcentage) {
    const points = Math.round(pourcentage * 100);
    return Math.abs(points - pourcentage * 100) < 1e-6 ? points : null;
}
function diviser(numerateur, denominateur, sens) {
    const quotient = numerateur / denominateur;
    const reste = numerateur % denominateur;
    if (reste === 0n)
        return quotient;
    if (sens === 'inferieur')
        return quotient;
    if (sens === 'superieur')
        return quotient + 1n;
    return reste * 2n >= denominateur ? quotient + 1n : quotient;
}
/**
 * Le nouveau prix public, en centimes, arrondi au pas demandé. Calcul entier
 * (`bigint`) : aucun flottant entre le prix lu et le prix écrit. `null` quand
 * le résultat n'est pas un prix (nul ou négatif).
 */
export function appliquerReglePrix(prixCentimes, regle, arrondi) {
    if (!Number.isSafeInteger(prixCentimes))
        return null;
    const pas = BigInt(arrondi.pasCentimes);
    let resultat;
    if (regle.mode === 'pourcentage') {
        const points = pointsDeBaseDe(regle.pourcentage);
        if (points === null)
            return null;
        const numerateur = BigInt(prixCentimes) * BigInt(10_000 + points);
        resultat = diviser(numerateur, 10000n * pas, arrondi.sens) * pas;
    }
    else {
        const brut = BigInt(prixCentimes) + BigInt(regle.deltaCentimes);
        if (brut <= 0n)
            return null;
        resultat = diviser(brut, pas, arrondi.sens) * pas;
    }
    // Au-delà des entiers sûrs, le `number` écrit ne serait plus le prix calculé.
    return resultat > 0n && resultat <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(resultat) : null;
}
//# sourceMappingURL=lot-oeuvres.js.map